<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="fitnessAndProprietyData ;  else loading" [formGroup]="fitnessAndProprietyForm">

    <div *ngFor="let category of questions_Category">
      <h1 class="bofa--heading is-4">{{category}} Questions</h1>
      <div *ngFor="let data of getQuestionsbasedCategory(category); let i=index" [formGroup]="data">
        <div #item>

          <span class="minor-list-space" [id]="'await-trial-label-' + i"><abbr title="required">*
            </abbr>{{data.controls.questions.value}}</span>

          <mat-radio-group [attr.aria-labelledby]="'await-trial-label-' + i" formControlName="answer" required
            class="bottom-space minor-radio-padding radio-flex">
            <mat-radio-button class="minor-list-space radio-padding field-space" value=1 name="answer">Yes
            </mat-radio-button>
            <mat-radio-button value=0 class="field-space" name="answer">No</mat-radio-button>
          </mat-radio-group>

          <div *ngIf="data.controls.answer.value === '1'">
            <mat-form-field class="max-zoom field-space non-required"
              *ngIf="fitnessAndProprietyData.jobCountryId !== 78">
              <mat-label>Please provide description</mat-label>
              <input matInput formControlName="description" maxlength="150">
            </mat-form-field>

            <label *ngIf="fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value === 53"
              id="descriptionDesc" for="descriptionInput" class="field-space">Please provide description and upload
              Court Order and Court Room Check (CRC) on the Certification Tab
            </label>

            <mat-form-field class="max-zoom field-space non-required-ous" aria-describedby="descriptionDesc"
              *ngIf="fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value === 53">
              <input id="descriptionInput" matInput formControlName="description" maxlength="150" placeholder="Please provide description">
            </mat-form-field>

            <mat-form-field class="max-zoom field-space non-required"
              *ngIf="fitnessAndProprietyData.jobCountryId === 78 && data.controls.questionId.value !== 53">
              <mat-label>Please provide description</mat-label>
              <input matInput formControlName="description" maxlength="150">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  <span *ngIf="isIndiaGBS">
    Loading Criminal History Questions...
  </span>
  <span *ngIf="!isIndiaGBS">
    Loading Fitness and Propriety Questions...
  </span>
</ng-template>